import React, { useEffect } from 'react';
import { DatePicker, Form } from 'antd';
import { useGetTransportLinesStatistics } from 'api/statistic/use-get-transport-lines-statistics';
import { useGoalsInsightsFilter } from 'shared/stores/use-goals-insights-filters';
import { transformAndSetFilters } from 'shared/utils/filters/transform-and-set-filters';
import { TransportLineFormSelect } from 'components/common/transport-line-form-select';
import { CargoTypeSelect } from 'components/statistics/goals-insights-header/components/cargo-type-select';
import styles from './goals-insights-header.module.scss';

export const GoalsInsightsHeader: React.FC = () => {
  const { filters, setFilters, clearFilters } = useGoalsInsightsFilter();
  const { data: transportLines } = useGetTransportLinesStatistics();

  const [form] = Form.useForm();

  const handleSuccess = () => {
    transformAndSetFilters(form, setFilters);
  };

  useEffect(() => {
    if (transportLines?.length && !filters.transportLine) {
      form.setFieldsValue({ transportLine: transportLines[0].slug });
      handleSuccess();
    }
  }, [transportLines]);

  useEffect(() => {
    return () => {
      clearFilters();
    };
  }, [clearFilters]);

  return (
    <Form form={form} initialValues={filters} className={styles.form}>
      <Form.Item name='date' className={styles.inputWrapper}>
        <DatePicker allowClear={false} className={styles.input} onChange={handleSuccess} />
      </Form.Item>
      <TransportLineFormSelect name='transportLine' className={styles.inputWrapper} onChange={handleSuccess} />
      <CargoTypeSelect className={styles.cargoTypesWrapper} onChange={handleSuccess} />
    </Form>
  );
};
